<template>
  <div class="px-4 sm:px-0 mt-3">
    <div class="flex flex-col sm:flex-row">
      <div class="flex-shrink-0 w-[175px] h-[304px] mx-auto sm:mx-0 bg-[#F6F3D9] rounded-lg overflow-hidden">
        <OImage :src="imageUrl" alt="Tarot Card" class="w-full h-full object-cover" />
      </div>
      <div class="mt-4 sm:mt-0 sm:ml-8 min-h-[304px] sm:w-full">
        <h2 class="text-28 font-bold">{{ card.title }}</h2>
        <figcaption v-if="card.text.html" class="text-lg font-normal">
          <div class="relative space-y-4" v-html="card.text.html"></div>
        </figcaption>
        <OButton
          pure
          class="u-center h-10 w-full sm:w-40 mt-6 mb-4 sm:mb-0 rounded-full bg-white text-black text-md font-medium"
          :href="selectionViewUrl"
        >
          Yeni kart seç
        </OButton>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import { getImageUrl } from '@/modules/common/utils/imageUtils';
import { OImage, OButton } from '~/modules/common/components/ui';
export default defineComponent({
  components: {
    OImage,
    OButton,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const imageUrl = getImageUrl(props.card.image, { standard: true });
    const selectionViewUrl = computed(() => props.card.route.substring(0, props.card.route.lastIndexOf('/')));
    return { imageUrl, selectionViewUrl };
  },
});
</script>
